<div class="owner-label font-weight-semibold" [class.customer-name]="!fromVandewiele">
  <span>{{ getLabelForOwner() }}</span>
</div>
